import { initTurnstileWidgets, resetFormTurnstile } from './turnstile.js';

/**
 * Turnstile
 */
function whenTurnstileReady(callback) {
    if (window.turnstile) {
        callback();
        return;
    }

    const interval = setInterval(() => {
        if (window.turnstile) {
            clearInterval(interval);
            callback();
        }
    }, 50);
}

document.addEventListener('DOMContentLoaded', () => {
    whenTurnstileReady(initTurnstileWidgets);
});

window.initTurnstileWidgets = initTurnstileWidgets;
window.resetFormTurnstile = resetFormTurnstile;

/**
 *
 * WebFont Loader.
 *
 */
import WebFont from 'webfontloader';
WebFont.load({
    google: {
        families: ['Inter:100,200,300,400,500,600,700,800,900']
    }
});

/**
 *
 * Alpine.js
 *
 */
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();